function fixChartWidth(chartWrapperEl, jsCode, { heightOperation = false } = {}) {
   if (!jsCode || jsCode === '') return '';

   let fixedJSCode = jsCode;
   const wrapperStyles = window.getComputedStyle(chartWrapperEl);
   const wrapperWidth = parseInt(wrapperStyles.width, 10);
   const wrapperPaddingLeft = parseInt(wrapperStyles.paddingLeft, 10);
   const wrapperPaddingRight = parseInt(wrapperStyles.paddingRight, 10);
   const wrapperContentWidth = wrapperWidth - (wrapperPaddingLeft + wrapperPaddingRight);

   const wrapperHeight = parseInt(wrapperStyles.height, 10);
   const wrapperPaddingTop = parseInt(wrapperStyles.paddingLeft, 10);
   const wrapperPaddingBottom = parseInt(wrapperStyles.paddingRight, 10);
   const wrapperContentHeight = wrapperHeight - (wrapperPaddingTop + wrapperPaddingBottom);

   const widthRegex = RegExp(/([{},]\s*\\?"?'?width\\?"?'?:\s*\\?"?'?)([\w%]*)(\\?"?'?)/);
   const matches = widthRegex.exec(jsCode);
   const chartWidth = parseInt(matches[2], 10);

   const heightRegex = RegExp(/([{},]\s*\\?"?'?height\\?"?'?:\s*\\?"?'?)([\w%]*)(\\?"?'?)/);
   const heightMatches = heightRegex.exec(jsCode);
   const chartHeight = parseInt(heightMatches[2], 10);

   if (chartWidth > wrapperContentWidth) {
      fixedJSCode = fixedJSCode.replace(widthRegex, `$1${wrapperContentWidth}$3`);
   }

   if (heightOperation && chartHeight > wrapperContentHeight) {
      fixedJSCode = fixedJSCode.replace(heightRegex, `$1${wrapperContentHeight}$3`);
   }

   return fixedJSCode;
}

export default {
   fixChartWidth,
};
